var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 5.7735,
    height: 40.5,
    viewBox: "0 0 5.7735 40.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Downward arrow",
    d: "M3.38675 0.5V0H2.38675V0.5H2.88675H3.38675ZM2.38675 1.48611V1.98611H3.38675V1.48611H2.88675H2.38675ZM3.38675 3.45833V2.95833H2.38675V3.45833H2.88675H3.38675ZM2.38675 5.43056V5.93056H3.38675V5.43056H2.88675H2.38675ZM3.38675 7.40278V6.90278H2.38675V7.40278H2.88675H3.38675ZM2.38675 9.375V9.875H3.38675V9.375H2.88675H2.38675ZM3.38675 11.3472V10.8472H2.38675V11.3472H2.88675H3.38675ZM2.38675 13.3194V13.8194H3.38675V13.3194H2.88675H2.38675ZM3.38675 15.2917V14.7917H2.38675V15.2917H2.88675H3.38675ZM2.38675 17.2639V17.7639H3.38675V17.2639H2.88675H2.38675ZM3.38675 19.2361V18.7361H2.38675V19.2361H2.88675H3.38675ZM2.38675 21.2083V21.7083H3.38675V21.2083H2.88675H2.38675ZM3.38675 23.1806V22.6806H2.38675V23.1806H2.88675H3.38675ZM2.38675 25.1528V25.6528H3.38675V25.1528H2.88675H2.38675ZM3.38675 27.125V26.625H2.38675V27.125H2.88675H3.38675ZM2.38675 29.0972V29.5972H3.38675V29.0972H2.88675H2.38675ZM3.38675 31.0694V30.5694H2.38675V31.0694H2.88675H3.38675ZM2.38675 33.0417V33.5417H3.38675V33.0417H2.88675H2.38675ZM3.38675 35.0139V34.5139H2.38675V35.0139H2.88675H3.38675ZM2.88675 0.5H2.38675V1.48611H2.88675H3.38675V0.5H2.88675ZM2.88675 3.45833H2.38675V5.43056H2.88675H3.38675V3.45833H2.88675ZM2.88675 7.40278H2.38675V9.375H2.88675H3.38675V7.40278H2.88675ZM2.88675 11.3472H2.38675V13.3194H2.88675H3.38675V11.3472H2.88675ZM2.88675 15.2917H2.38675V17.2639H2.88675H3.38675V15.2917H2.88675ZM2.88675 19.2361H2.38675V21.2083H2.88675H3.38675V19.2361H2.88675ZM2.88675 23.1806H2.38675V25.1528H2.88675H3.38675V23.1806H2.88675ZM2.88675 27.125H2.38675V29.0972H2.88675H3.38675V27.125H2.88675ZM2.88675 31.0694H2.38675V33.0417H2.88675H3.38675V31.0694H2.88675ZM2.88675 35.0139H2.38675V36H2.88675H3.38675V35.0139H2.88675ZM2.88675 40.5L5.7735 35.5H0L2.88675 40.5Z",
    fill: "url(#paint0_linear_0_34)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_34",
    x1: 3.38675,
    y1: 0.5,
    x2: 3.38675,
    y2: 40.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59402",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59402",
    stopOpacity: 0.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepArrow);
export default __webpack_public_path__ + "static/media/step-arrow.745ec9840fc383653b1c22d409ab84af.svg";
export { ForwardRef as ReactComponent };